const { default: Vue } = require("vue");

Vue.component("create-payment-component", require("./Create.vue").default);
Vue.component("toggle-payment-component", require("./Toggle.vue").default);
Vue.component("edit-payment-component", require("./Edit.vue").default);
Vue.component("delete-payment-component", require("./Delete.vue").default);
Vue.component("manage-payment-component", require("./Manage.vue").default);
